import { Router } from '@angular/router';
import { AnalyticsService } from './analytics.service';
import { HostListener, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
// import { Firestore } from '@angular/fire/firestore';
// import { HttpClient } from '@angular/common/http';
// import { map } from 'rxjs';
import { ModalService } from './modal.service';
import { Platform } from '@angular/cdk/platform';

@Injectable({
  providedIn: 'root',
})
export class InstallService {
  installEvent!: Event;
  constructor(
    private sw: SwUpdate,
    private modalService: ModalService,
    private analytics: AnalyticsService,
    private router: Router,
    // private firestore: Firestore,
    private platform: Platform,
  ) {
    // document.addEventListener('visibilitychange', () => {
    //   const state = document.visibilityState;
    //   if (state === 'hidden') {
    //     // your PWA is now in the background
    //     // this.reload();
    //   }
    //   if (state === 'visible') {
    //     // your PWA is now in the foreground
    //     // this.reload();
    //   }
    // });
    // console.log(`Triggering Install Modal...`, this.platform.ANDROID);
    // window.addEventListener('beforeinstallprompt', (event) => {
    //   event.preventDefault();
    //   this.installEvent = event;
    //   if (!window.matchMedia('(display-mode: standalone)').matches) {
    //     this.onBeforeInstallPrompt();
    //   }
    // });
  }

  // @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt() {
    const installPrompt = setInterval(() => {
      console.log(`Triggering Install Modal...`);
      this.modalService.open('install_modal');
      clearInterval(installPrompt);
    }, 3000);
  }

  start() {
    console.log(`Starting PWA Version Sync...`);
    this.sw.versionUpdates.subscribe((evt) => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.log(`Downloading new app version...`);
          break;
        case 'VERSION_READY':
          // console.log(`Current app version: ${evt.currentVersion.hash}`);
          console.log(`New app version ready for use`);

          // Open Install Modal here
          this.modalService.open('update_modal');

          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.log(
            `Failed to install app version '${evt.version.hash}': ${evt.error}`,
          );
          this.analytics.swVersionUpdateFailed(evt.version.hash, evt.error);
          break;
      }
    });
  }

  // async loadAppData() {
  //   // const httpOptions: Object = {responseType: 'text'};

  //   // const res = this.http.get<any>(`https://europe-west2-pay-am.cloudfunctions.net/serve/app-data-bundle`, httpOptions);
  //   return await fetch(
  //     'https://europe-west2-pay-am.cloudfunctions.net/serve/app-data-bundle',
  //   ).then(async (resp) => {
  //     return await loadBundle(this.firestore, resp.body!)
  //       .then((value) => {
  //         // console.log(value)
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   });

  //   // res.subscribe((value) => {
  //   //   console.log(value);
  //   // })
  // }

  reloadForCapacitorInjection() {
    const scripts = document.querySelectorAll(
      "head script[type='text/javascript']:not([src])",
    );
    // console.log(scripts);
    console.log('Looking for Script with Capacitor');
    let matches = [];

    if (scripts.length) {
      scripts.forEach((script, index) => {
        if (
          script &&
          script.textContent?.includes('Capacitor') &&
          script.id !== 'script'
        ) {
          matches.push(script);
          console.log('found Script with Capacitor');
        } else if (index + 1 == scripts.length && matches.length < 1) {
          console.log('reloading no Capacitor');
          location.reload();
        }
      });
    } else {
      console.log('reloading no Capacitor');
      location.reload();
    }
  }

  installApp() {
    // Prompt install
    (this.installEvent as any).prompt();

    // Check if user has installed or not
    // (this.installEvent as any)!.userChoice().then((result: any) => {
    //   if(result.outcome == 'dismissed') {
    //     //TODO: track refused install

    //   } else {
    //     // TODO: Track install option

    //   }
    // })

    return;
  }

  reload() {
    // location.reload();
    // this.router.navigateByUrl('/');
    // setTimeout(() => {
    //   // this.modalService.open('new_update_modal');
    //   // this.modalService.open(modalMessage?.modal);
    // }, 500)
    // this.sw.activateUpdate().then(() => {
    // })
  }
}
